import DataTable from "./src/index.vue";
import type { App } from "vue";
DataTable.install = function (Vue: App): void {
  console.info("DataTable----install----");
  Vue.component(DataTable.name, DataTable);
};

export default DataTable;
